import { render } from "./map.vue?vue&type=template&id=8bcbce9c&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import "./map.vue?vue&type=style&index=0&id=8bcbce9c&lang=scss&scoped=true"

import exportComponent from "/Users/waiting/Desktop/代码库/musich5/代码/musicweapons/frontend/music/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bcbce9c"]])

export default __exports__